(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kzk-07-rechner"] && !Shopify.designMode) return;
  try {
    
  /** Parses an inline JSON script inside root; no dependency on the shared module's load order. */
  const kzkJson = (root, selector) => {
    try {
      const node = root.querySelector(selector);
      return node ? JSON.parse(node.textContent || 'null') : null;
    } catch {
      return null;
    }
  };
  class KzkValidityCalc extends HTMLElement {
    #controller = new AbortController();

    connectedCallback() {
      const { signal } = this.#controller;
      this.strings = kzkJson(this, '[data-kzk-strings]') || {};
      this.plateCard = this.closest('.kzk-grid')?.querySelector('[data-kzk-plate-card]') || null;
      for (const input of this.querySelectorAll('input[data-kzk-date]')) {
        input.addEventListener(
          'input',
          () => {
            this.#mask(input);
            const group = this.querySelector(`[data-kzk-presets="${input.dataset.kzkDate}"]`);
            if (group && typeof group.select === 'function') group.select(this.#presetFor(input.value), true);
            this.update();
          },
          { signal }
        );
        input.addEventListener(
          'blur',
          () => {
            const date = this.#parse(input.value);
            if (date) input.value = this.#format(date, false);
          },
          { signal }
        );
      }
      this.addEventListener('kzk:change', this.#handlePreset, { signal });
      this.update();
    }

    disconnectedCallback() {
      this.#controller.abort();
    }

    get today() {
      return this.#parse(this.dataset.today) || new Date();
    }

    /**
     * Reads a typed date (dd.mm.yyyy, the order of the date format) or an ISO date.
     * @param {string} text
     */
    #parse(text) {
      if (!text) return null;
      let y, m, d;
      if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
        [y, m, d] = text.split('-').map(Number);
      } else {
        const digits = text.replace(/\D/g, '');
        if (digits.length !== 8) return null;
        const format = this.dataset.dateFormat || '%d.%m.%Y';
        const parts = { d: Number(digits.slice(0, 2)), m: Number(digits.slice(2, 4)), y: Number(digits.slice(4, 8)) };
        if (format.indexOf('%Y') < format.indexOf('%d')) {
          parts.y = Number(digits.slice(0, 4));
          parts.m = Number(digits.slice(4, 6));
          parts.d = Number(digits.slice(6, 8));
        } else if (format.indexOf('%m') < format.indexOf('%d')) {
          parts.m = Number(digits.slice(0, 2));
          parts.d = Number(digits.slice(2, 4));
        }
        ({ y, m, d } = parts);
      }
      if (!y || !m || !d || m > 12 || d > 31) return null;
      const date = new Date(y, m - 1, d);
      return date.getMonth() === m - 1 && date.getDate() === d ? date : null;
    }

    /**
     * Inserts the separators of the date format while typing (14102026 -> 14.10.2026).
     * @param {HTMLInputElement} input
     */
    #mask(input) {
      const format = this.dataset.dateFormat || '%d.%m.%Y';
      const separator = (format.match(/[^%\w]/) || ['.'])[0];
      const lengths = format.indexOf('%Y') < format.indexOf('%d') ? [4, 2, 2] : [2, 2, 4];
      const digits = input.value.replace(/\D/g, '').slice(0, 8);
      let out = '';
      let used = 0;
      for (const length of lengths) {
        if (used >= digits.length) break;
        if (out) out += separator;
        out += digits.slice(used, used + length);
        used += length;
      }
      if (out !== input.value) input.value = out;
    }

    /** @param {Date} date */
    #iso(date) {
      const pad = (n) => String(n).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    }

    /** @param {Date} date @param {number} days */
    #addDays(date, days) {
      const next = new Date(date);
      next.setDate(next.getDate() + days);
      return next;
    }

    /** @param {string} text */
    #presetFor(text) {
      const date = this.#parse(text);
      const iso = date ? this.#iso(date) : '';
      if (iso === this.#iso(this.today)) return 'today';
      if (iso === this.#iso(this.#addDays(this.today, 1))) return 'tomorrow';
      return 'custom';
    }

    /** @param {Date} date @param {boolean} [withWeekday] */
    #format(date, withWeekday = true) {
      const pad = (n) => String(n).padStart(2, '0');
      const format = this.dataset.dateFormat || '%d.%m.%Y';
      const text = format
        .replace('%d', pad(date.getDate()))
        .replace('%m', pad(date.getMonth() + 1))
        .replace('%Y', String(date.getFullYear()))
        .replace('%y', String(date.getFullYear()).slice(-2));
      if (!withWeekday) return text;
      const weekdays = (this.dataset.weekdays || '').split(',');
      return `${weekdays[date.getDay()] || ''} ${text}`.trim();
    }

    /** @param {CustomEvent} event */
    #handlePreset = (event) => {
      const group = event.target instanceof Element ? event.target.closest('[data-kzk-presets]') : null;
      if (!group) return;
      const input = this.querySelector(`input[data-kzk-date="${group.dataset.kzkPresets}"]`);
      if (!(input instanceof HTMLInputElement)) return;
      const value = event.detail && event.detail.value;
      if (value === 'today') input.value = this.#format(this.today, false);
      else if (value === 'tomorrow') input.value = this.#format(this.#addDays(this.today, 1), false);
      else if (value === 'custom') {
        input.focus();
        input.select();
      }
      this.update();
    };

    update() {
      const orderInput = this.querySelector('input[data-kzk-date="order"]');
      const regInput = this.querySelector('input[data-kzk-date="reg"]');
      const empty = this.querySelector('[data-kzk-calc-empty]');
      const rows = this.querySelectorAll('[data-kzk-calc-row]');
      const hint = this.querySelector('[data-kzk-calc-hint]');
      const hintText = this.querySelector('[data-kzk-calc-hint-text]');
      const evbDays = Number(this.dataset.evbDays);
      const coverDays = Number(this.dataset.coverDays);
      const order = orderInput instanceof HTMLInputElement ? this.#parse(orderInput.value) : null;
      const reg = regInput instanceof HTMLInputElement ? this.#parse(regInput.value) : null;

      if (!order) {
        if (empty) empty.hidden = false;
        for (const row of rows) row.hidden = true;
        if (hint) hint.hidden = true;
        return;
      }
      if (empty) empty.hidden = true;
      for (const row of rows) row.hidden = false;

      const evbEnd = this.#addDays(order, evbDays);
      const regDate = reg || order;
      const coverEnd = this.#addDays(regDate, Math.max(0, coverDays - 1));

      const evbOut = this.querySelector('[data-kzk-calc-out="evb"]');
      const coverOut = this.querySelector('[data-kzk-calc-out="cover"]');
      if (evbOut) evbOut.textContent = this.#format(evbEnd);
      if (coverOut) coverOut.textContent = this.#format(coverEnd);

      const outOfRange = regDate < order || regDate > evbEnd;
      if (hint && hintText) {
        hint.hidden = !outOfRange;
        hintText.textContent = (this.strings.hintRange || '').split('[datum]').join(this.#format(evbEnd));
      }

      this.#updatePlateCard(order, regDate, coverEnd, evbEnd, evbDays, coverDays);
    }

    #updatePlateCard(order, reg, coverEnd, evbEnd, evbDays, coverDays) {
      const card = this.plateCard;
      if (!card) return;
      const pad = (n) => String(n).padStart(2, '0');
      const expiry = card.querySelector('[data-kzk-plate-expiry]');
      if (expiry) {
        const spans = expiry.querySelectorAll('span');
        if (spans.length === 3) {
          spans[0].textContent = pad(coverEnd.getDate());
          spans[1].textContent = pad(coverEnd.getMonth() + 1);
          spans[2].textContent = String(coverEnd.getFullYear()).slice(-2);
        }
      }
      const title = card.querySelector('[data-kzk-window-title]');
      if (title) {
        const isToday = this.#iso(order) === this.#iso(this.today);
        title.textContent = isToday
          ? this.strings.windowToday || title.textContent
          : (this.strings.windowFrom || '').split('[datum]').join(this.#format(order, false));
      }
      const strip = card.querySelector('[data-kzk-strip]');
      if (strip) {
        const names = (this.dataset.weekdaysShort || '').split(',');
        const days = strip.querySelectorAll('.kzk-rechner__day');
        const coverStart = Math.round((reg - order) / 86400000);
        days.forEach((day, i) => {
          const date = this.#addDays(order, i);
          const name = day.querySelector('.kzk-rechner__day-name');
          const num = day.querySelector('.kzk-rechner__day-num');
          if (name) name.textContent = names[date.getDay()] || '';
          if (num) num.textContent = pad(date.getDate());
          day.classList.toggle('kzk-rechner__day--cover', i >= coverStart && i < coverStart + coverDays);
        });
      }
      const legend = card.querySelector('[data-kzk-legend-evb]');
      if (legend) {
        const daysText = (this.strings.days || '').replace(/\{\{\s*count\s*\}\}/, String(evbDays));
        legend.textContent = (this.strings.legendEvb || '')
          .split('[datum]').join(`${pad(evbEnd.getDate())}.${pad(evbEnd.getMonth() + 1)}.`)
          .split('[tage]').join(daysText);
      }
    }
  }

  if (!customElements.get('kzk-validity-calc')) customElements.define('kzk-validity-calc', KzkValidityCalc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kzk-13-themenmenue"] && !Shopify.designMode) return;
  try {
    
  class KzkTopicMenu extends HTMLElement {
    #controller = new AbortController();

    connectedCallback() {
      const { signal } = this.#controller;
      this.toggle = this.querySelector('[data-kzk-topic-toggle]');
      this.nav = this.querySelector('[data-kzk-topic-nav]');
      if (!this.toggle || !this.nav) return;
      this.#setOpen(false);
      this.toggle.addEventListener('click', () => this.#setOpen(!this.open), { signal });
      this.nav.addEventListener(
        'click',
        (event) => {
          if (event.target instanceof Element && event.target.closest('a')) this.#setOpen(false);
        },
        { signal }
      );
      this.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'Escape' && this.open) {
            this.#setOpen(false);
            this.toggle.focus();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#controller.abort();
    }

    get open() {
      return this.toggle.getAttribute('aria-expanded') === 'true';
    }

    /** @param {boolean} open */
    #setOpen(open) {
      this.toggle.setAttribute('aria-expanded', String(open));
      if (open) this.nav.removeAttribute('data-collapsed');
      else this.nav.setAttribute('data-collapsed', '');
      const iconOpen = this.querySelector('[data-kzk-icon-open]');
      const iconClose = this.querySelector('[data-kzk-icon-close]');
      if (iconOpen) iconOpen.hidden = open;
      if (iconClose) iconClose.hidden = !open;
    }
  }

  if (!customElements.get('kzk-topic-menu')) customElements.define('kzk-topic-menu', KzkTopicMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kzk-17-kostenrechner"] && !Shopify.designMode) return;
  try {
    
  /** Parses an inline JSON script inside root; no dependency on the shared module's load order. */
  const kzkJson = (root, selector) => {
    try {
      const node = root.querySelector(selector);
      return node ? JSON.parse(node.textContent || 'null') : null;
    } catch {
      return null;
    }
  };
  class KzkCostCalc extends HTMLElement {
    #controller = new AbortController();

    connectedCallback() {
      const { signal } = this.#controller;
      this.strings = kzkJson(this, '[data-kzk-strings]') || {};
      this.select = this.querySelector('[data-kzk-variant]');
      this.range = this.querySelector('[data-kzk-plates]');
      if (this.select) this.select.addEventListener('change', () => this.update(), { signal });
      if (this.range) this.range.addEventListener('input', () => this.update(), { signal });
      this.update();
    }

    disconnectedCallback() {
      this.#controller.abort();
    }

    /** @param {number} cents */
    #money(cents) {
      return window.KzkMoney ? window.KzkMoney.format(cents, this.dataset.moneyFormat) : String(cents / 100);
    }

    update() {
      const select = this.select;
      const range = this.range;
      if (!(select instanceof HTMLSelectElement) || !(range instanceof HTMLInputElement)) return;
      const option = select.selectedOptions[0];
      const price = option ? Number(option.dataset.price) || 0 : 0;
      const label = option ? option.dataset.label || '' : '';
      const plates = Math.round(Number(range.value) * 100);
      const fee = Number(this.dataset.fee) || 0;
      const total = price + fee + plates;

      const platesOut = this.querySelector('[data-kzk-plates-out]');
      const rowEvb = this.querySelector('[data-kzk-row-evb]');
      const rowPlates = this.querySelector('[data-kzk-row-plates]');
      const totalOut = this.querySelector('[data-kzk-total]');
      const ctaLabel = this.querySelector('[data-kzk-cta-label]');
      const cta = this.querySelector('[data-kzk-cta]');

      if (platesOut) platesOut.textContent = this.#money(plates);
      if (rowEvb) {
        rowEvb.textContent = this.#money(price);
        const rowLabel = rowEvb.previousElementSibling;
        if (rowLabel && this.strings.rowEvb) {
          rowLabel.textContent = this.strings.rowEvb.split('[auswahl]').join(label);
        }
      }
      if (rowPlates) rowPlates.textContent = this.#money(plates);
      if (totalOut) totalOut.textContent = this.#money(total);
      if (ctaLabel && this.strings.orderFor) {
        ctaLabel.textContent = this.strings.orderFor.split('[preis]').join(this.#money(price));
      }
      if (cta instanceof HTMLAnchorElement && option && this.dataset.urlOrder) {
        const base = this.dataset.urlOrder;
        const [path, hash] = base.split('#');
        const joiner = path.includes('?') ? '&' : '?';
        cta.href = `${path}${joiner}variant=${encodeURIComponent(option.value)}${hash ? `#${hash}` : ''}`;
      }
      range.setAttribute('aria-valuetext', this.#money(plates));
    }
  }

  if (!customElements.get('kzk-cost-calc')) customElements.define('kzk-cost-calc', KzkCostCalc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kzk-25-faq"] && !Shopify.designMode) return;
  try {
    
  /** Parses an inline JSON script inside root; no dependency on the shared module's load order. */
  const kzkJson = (root, selector) => {
    try {
      const node = root.querySelector(selector);
      return node ? JSON.parse(node.textContent || 'null') : null;
    } catch {
      return null;
    }
  };
  class KzkFaq extends HTMLElement {
    #controller = new AbortController();
    #timer = 0;

    connectedCallback() {
      const { signal } = this.#controller;
      this.strings = kzkJson(this, '[data-kzk-strings]') || {};
      this.search = this.querySelector('[data-kzk-faq-search]');
      this.filter = this.querySelector('[data-kzk-faq-filter]');
      this.category = this.dataset.preset || 'alle';
      this.query = '';

      if (this.search) {
        this.search.addEventListener(
          'input',
          () => {
            window.clearTimeout(this.#timer);
            this.#timer = window.setTimeout(() => {
              this.query = this.search.value.trim();
              this.apply();
            }, 180);
          },
          { signal }
        );
      }
      if (this.filter) {
        this.filter.addEventListener(
          'kzk:change',
          (event) => {
            this.category = (event.detail && event.detail.value) || 'alle';
            this.apply();
          },
          { signal }
        );
      }
      const reset = this.querySelector('[data-kzk-faq-reset]');
      if (reset) {
        reset.addEventListener(
          'click',
          () => {
            if (this.search) this.search.value = '';
            this.query = '';
            this.apply();
            if (this.search) this.search.focus();
          },
          { signal }
        );
      }
      this.#applyHash();
      window.addEventListener('hashchange', () => this.#applyHash(), { signal });
      this.apply();
    }

    disconnectedCallback() {
      this.#controller.abort();
      window.clearTimeout(this.#timer);
    }

    /** A category in the URL hash (#kosten) preselects it and brings the section into view */
    #applyHash() {
      const hash = window.location.hash.replace('#', '');
      if (!hash || !this.filter) return;
      const button = this.filter.querySelector(`button[data-value="${CSS.escape(hash)}"]`);
      if (!button) return;
      this.category = hash;
      if (typeof this.filter.select === 'function') this.filter.select(hash, true);
      this.apply();
      const section = this.closest('.kzk');
      if (section && !document.getElementById(hash)) section.scrollIntoView({ block: 'start' });
    }

    /** @param {string} text */
    #normalize(text) {
      return window.kzkNormalize ? window.kzkNormalize(text) : String(text || '').toLowerCase();
    }

    /** @param {HTMLElement} item @param {string} query */
    #highlight(item, query) {
      const target = item.querySelector('[data-kzk-faq-question]');
      if (!target) return;
      const original = item.dataset.question || target.textContent || '';
      if (!query) {
        target.textContent = original;
        return;
      }
      const normalized = this.#normalize(original);
      const needle = this.#normalize(query);
      const index = normalized.indexOf(needle);
      if (index === -1 || normalized.length !== original.length) {
        target.textContent = original;
        return;
      }
      target.textContent = '';
      target.append(original.slice(0, index));
      const mark = document.createElement('mark');
      mark.textContent = original.slice(index, index + needle.length);
      target.append(mark, original.slice(index + needle.length));
    }

    apply() {
      const items = Array.from(this.querySelectorAll('[data-kzk-faq-item]'));
      const groups = Array.from(this.querySelectorAll('[data-kzk-faq-group]'));
      const status = this.querySelector('[data-kzk-faq-status]');
      const empty = this.querySelector('[data-kzk-faq-empty]');
      const emptyTitle = this.querySelector('[data-kzk-faq-empty-title]');
      const query = this.query;
      const needle = this.#normalize(query);
      let count = 0;
      let first = null;

      for (const item of items) {
        const inCategory = this.category === 'alle' || item.dataset.category === this.category;
        const text = this.#normalize(`${item.dataset.question || ''} ${item.textContent || ''}`);
        const matches = !needle || text.includes(needle);
        const visible = inCategory && matches;
        item.hidden = !visible;
        this.#highlight(item, visible ? query : '');
        if (visible) {
          count += 1;
          if (!first) first = item;
        }
      }
      for (const group of groups) {
        group.hidden = Boolean(needle) || (this.category !== 'alle' && group.dataset.kzkFaqGroup !== this.category);
      }
      if (needle && first && !first.open) first.open = true;

      const s = this.strings;
      if (status) {
        let text = '';
        if (needle && count > 0) {
          text = (count === 1 ? s.resultsSearchOne : s.resultsSearch) || '';
        } else if (!needle && this.category !== 'alle') {
          text = (count === 1 ? s.resultsCategoryOne : s.resultsCategory) || '';
        }
        const categoryButton = this.filter ? this.filter.querySelector(`button[data-value="${CSS.escape(this.category)}"]`) : null;
        const label = categoryButton ? categoryButton.textContent.trim() : this.category;
        text = text
          .replace(/\{\{\s*count\s*\}\}|\[anzahl\]/g, String(count))
          .replace(/\{\{\s*query\s*\}\}|\[suchbegriff\]/g, query)
          .replace(/\{\{\s*category\s*\}\}|\[kategorie\]/g, label);
        status.textContent = text;
        status.hidden = !text;
      }
      if (empty && emptyTitle) {
        const showEmpty = Boolean(needle) && count === 0;
        empty.hidden = !showEmpty;
        emptyTitle.textContent = (s.noResults || '').split('[suchbegriff]').join(query);
      }
    }
  }

  if (!customElements.get('kzk-faq')) customElements.define('kzk-faq', KzkFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
